
/* injects from baggage-loader */

'use strict';

export default class StageCardController {
    constructor($log, $state) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
    }

    goTo(route){
        this.$state.go(route);
        this.onClick();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/stage-card/stage-card.controller.js